/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharechannelgeneral2Inputs */

const en_sharechannelgeneral2 = /** @type {(inputs: Sharechannelgeneral2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const de_sharechannelgeneral2 = /** @type {(inputs: Sharechannelgeneral2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemein`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Sharechannelgeneral2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharechannelgeneral2 = /** @type {((inputs?: Sharechannelgeneral2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharechannelgeneral2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharechannelgeneral2(inputs)
	return de_sharechannelgeneral2(inputs)
});
export { sharechannelgeneral2 as "shareChannelGeneral" }